import React, {useCallback} from 'react'
import {Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, Stack, Typography} from '@mui/material'
import DraggableDialogTitle from './DraggableDialogTitle'
import {ExtraSmallButton} from "../custom";
import ClearIcon from "../../assets/icons/ClearIcon";

type ReusableDialogProps = {
    open: boolean
    onClose: () => void
    onSubmit: () => void
    title?: string
    content: string | any
    cancelVariant?: 'text' | 'outlined' | 'contained'
    submitVariant?: 'text' | 'outlined' | 'contained'
    cancelText?: string
    submitText?: string
    cancelButtonProps?: ButtonProps
    submitButtonProps?: ButtonProps
    fullWidth?: boolean
    maxWidth?: DialogProps['maxWidth']
    buttonSize?: 'small' | 'medium' | 'large'
}

const ReusableDialog: React.FC<ReusableDialogProps> = ({
                                                           open,
                                                           onClose,
                                                           onSubmit,
                                                           title,
                                                           content,
                                                           cancelVariant = 'text',
                                                           submitVariant = 'contained',
                                                           cancelText = 'Cancel',
                                                           submitText = 'Submit',
                                                           cancelButtonProps,
                                                           submitButtonProps,
                                                           fullWidth = true,
                                                           maxWidth = 'sm',
                                                           buttonSize = 'small'
                                                       }) => {
    const handleSubmit = useCallback(() => {
        onSubmit()
        onClose()
    }, [onSubmit, onClose])

    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
            {title && <DraggableDialogTitle>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Typography variant={'h6'}>{title}</Typography>
                    <ExtraSmallButton onClick={onClose} aria-label="close" color={"inherit"}>
                        <ClearIcon/>
                    </ExtraSmallButton>
                </Stack>
            </DraggableDialogTitle>}
            <DialogContent sx={!title ? { p: 2 } : content ? {} : { py: 0, px: 2 }}>
                {content && (
                    typeof content === 'string' ?
                    <Typography variant={"body2"}>{content}</Typography> : content
                )}
            </DialogContent>
            <DialogActions sx={{px: 2, py: 1}}>
                <Button onClick={onClose} variant={cancelVariant} size={buttonSize} {...cancelButtonProps}>
                    {cancelText}
                </Button>
                <Button variant={submitVariant} onClick={handleSubmit} size={buttonSize} {...submitButtonProps}>
                    {submitText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ReusableDialog
